<script setup lang="ts">
import { Language } from '@/core/collections/api/language/language.interface';

// #region globals
const { dispatch, state } = useStore();
// #endregion

// #region props & emits
const emits = defineEmits<{
   reload: [];
}>();
// #endregion

// #region filter german out
const user_info = computed(() => state.user?.user_info);
const languagesWithoutGerman = computed(() => state.language?.languages?.filter((lang: Language) => lang.key !== 'de') || []);
// #endregion

// #region select & initial value
const selected_language = ref<Language | null>(null);
watch(
   user_info,
   (new_value) => {
      selected_language.value = new_value?.language || null;
   },
   { immediate: true, deep: true },
);
// #endregion

// #region save
const is_updating = ref<boolean>(false);

async function saveLanguageAndReload(language: Language | null) {
   if (!language) return;

   selected_language.value = language;

   is_updating.value = true;
   await dispatch('user/patchLanguage', { language_id: selected_language.value?.id }).then(() => {
      emits('reload');
      is_updating.value = false;
   });
}
// #endregion
</script>

<template>
   <NxtSection :title="$t('profile.language')">
      <div class="language__picker">
         <template v-if="selected_language">
            <NxtSelect
               v-model="selected_language.id"
               class="language__picker__dropdown"
               :disabled="is_updating"
               :display-key="'name'"
               :emit-object="true"
               :has-clear-option="false"
               :placeholder="$t('global.select')"
               :name="'Language'"
               :options="languagesWithoutGerman"
               @on-emit-object="saveLanguageAndReload"
            />
         </template>
      </div>
   </NxtSection>
</template>

<style lang="scss" scoped>
.language__picker {
   display: flex;
   flex-direction: column;
   gap: var(--nxt-gutter);
   align-items: flex-start;
   padding: var(--nxt-gutter);
}
.language__picker__dropdown {
   width: toRem(240);
}

.language__picker__button {
   width: fit-content;
}
</style>
